export enum OtDataEntryRequirement {
  Mandatory = 'MANDATORY',
  Optional = 'OPTIONAL',
  Forbidden = 'FORBIDDEN',
}
